import { render, staticRenderFns } from "./causes-data.vue?vue&type=template&id=c3dc0732"
import script from "./causes-data.vue?vue&type=script&lang=js"
export * from "./causes-data.vue?vue&type=script&lang=js"
import style0 from "./causes-data.vue?vue&type=style&index=0&id=c3dc0732&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports